import LeftNav from './LeftNav.js';

export default LeftNav;
